/* IB-7 v15, Zusatz-JS der Wissens- und Markenseiten (Theme-Port 14.10.2026). Vanilla JS, defer.
   Newsletter "Inside IB-7": Die angehakten Rollen werden beim Absenden als Tags am Kunden gesetzt
   (contact[tags] = Basis-Tag plus ritual-<Nummer>). Ohne JS bleibt der Standardwert mit allen Rollen. */
(function () {
  'use strict';
  document.querySelectorAll('form').forEach(function (form) {
    var tags = form.querySelector('[data-w-tags]');
    if (!tags) return;
    var boxes = form.id ? document.querySelectorAll('[data-w-rolle][form="' + form.id + '"]') : [];
    if (!boxes.length) return;
    form.addEventListener('submit', function () {
      var list = [tags.getAttribute('data-w-base') || 'ritual-news'];
      boxes.forEach(function (b) { if (b.checked) list.push('ritual-' + b.value); });
      tags.value = list.join(', ');
    });
  });
})();
